// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__lMbF8","selects":"Documents_selects__2JZS0"};